var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 409.877 409.877",
    style: {
      enableBackground: "new 0 0 409.877 409.877"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333E48"
    },
    cx: 161.407,
    cy: 266.463,
    r: 50.021
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D68512"
    },
    cx: 161.407,
    cy: 266.463,
    r: 37.304
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333E48"
    },
    cx: 161.407,
    cy: 150.468,
    r: 50.021
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D68512"
    },
    cx: 161.407,
    cy: 150.468,
    r: 37.304
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M132.597,242.97c-7.353-7.353-17.51-11.9-28.73-11.9c-22.44,0-40.631,18.19-40.631,40.63v0.003 C28.312,271.703,0,243.391,0,208.465c-0.001-34.923,28.313-63.234,63.235-63.234c0,22.44,18.191,40.631,40.631,40.631 c11.22,0,21.378-4.549,28.73-11.901v69.009H132.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68512"
    },
    d: "M103.866,185.862c-17.728,0-32.794-11.357-38.344-27.189h-2.288 c-27.499,0-49.792,22.292-49.792,49.792c0,27.499,22.293,49.792,49.792,49.792h2.288c5.55-15.832,20.617-27.188,38.344-27.188 c11.22,0,21.378,4.548,28.73,11.9V173.96C125.244,181.314,115.086,185.862,103.866,185.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M103.866,185.862c-9.791,0-18.768-3.47-25.78-9.24c4.74,9.604,7.414,20.409,7.414,31.843 s-2.675,22.24-7.415,31.844c7.013-5.77,15.99-9.24,25.781-9.24c11.22,0,21.378,4.548,28.73,11.9V173.96 C125.244,181.314,115.086,185.862,103.866,185.862z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M235.191,201.606v-90.278c0-13.593,11.059-24.652,24.652-24.652 c56.758,0,102.935,46.177,102.935,102.935v11.995L235.191,201.606L235.191,201.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68512"
    },
    d: "M350.783,189.611c0-50.225-40.715-90.94-90.939-90.94c-6.991,0-12.656,5.666-12.656,12.657v78.283 H350.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M235.191,208.271v90.278c0,13.593,11.059,24.652,24.652,24.652 c56.758,0,102.935-46.177,102.935-102.935v-11.995L235.191,208.271L235.191,208.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68512"
    },
    d: "M350.783,220.266c0,50.225-40.715,90.939-90.939,90.939c-6.991,0-12.656-5.666-12.656-12.657 v-78.283L350.783,220.266L350.783,220.266z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9E16"
    },
    d: "M326.061,124.649H173.68c-46.289,0-83.818,37.526-83.818,83.817 c0,46.292,37.527,83.819,83.818,83.819h152.381c46.29,0,83.818-37.527,83.816-83.819 C409.879,162.175,372.351,124.649,326.061,124.649z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.191,
    y: 124.649,
    style: {
      fill: "#333E48"
    },
    width: 11.996,
    height: 167.758
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M111.417,152.252c-13.362,14.849-21.555,34.665-21.555,56.215c0,21.548,8.139,41.192,21.501,56.042 L111.417,152.252z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.931,
    y: 124.649,
    style: {
      fill: "#E8E8E8"
    },
    width: 31.261,
    height: 167.636
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M111.417,152.252l-0.054,112.257c4.226,4.696,8.982,8.9,14.163,12.544l0.137-137.296 C120.483,143.402,115.643,147.555,111.417,152.252z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#333E48"
    },
    points: "188.332,124.649 188.285,292.332 204.258,292.282 204.258,124.649  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333E48"
    },
    cx: 347.074,
    cy: 186.806,
    r: 9.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M316.867,208.466c0-30.695,10.333-59.043,27.598-81.79c-5.871-1.441-12.104-2.027-18.405-2.027 h-19.505c-14.245,24.693-22.402,53.32-22.402,83.817c0,30.498,8.158,59.125,22.403,83.819h19.504 c6.301,0,12.433-0.719,18.336-2.036C327.13,267.501,316.867,239.162,316.867,208.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M305.963,208.466c0-31.042,9.717-59.853,26.255-83.568c-2.034-0.148-4.084-0.25-6.157-0.25h-6.762 c-15.345,24.283-24.241,53.03-24.241,83.817c0,30.789,8.897,59.535,24.242,83.819h6.761c2.073,0,4.123-0.103,6.158-0.25 C315.68,268.319,305.963,239.508,305.963,208.466z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M228.025,161.537c-22.129,22.129-22.129,58.008,0,80.138l40.069-40.07L228.025,161.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68512"
    },
    d: "M234.975,168.486c-8.476,8.476-13.718,20.185-13.718,33.119s5.242,24.644,13.719,33.12 l33.119-33.12L234.975,168.486z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNemo);
export default __webpack_public_path__ + "static/media/nemo.eb171896d781eb7ac4d87b059baf5862.svg";
export { ForwardRef as ReactComponent };